<template>
  <div class="tender-steps">
    <div
      v-for="(stepItem, stepIndex) in steps"
      :key="stepIndex"
      class="tender-steps_item"
      :class="{'is-active': !loading && stepIndex + 1 === +value, 'is-disabled': disabled}"
      @click="changeStep(stepIndex + 1)">
      <sTooltip
        :border="false"
        :content="$t(`Tenders.${stepItem.text}`)"
        :disabled="stepIndex + 1 === +value"
        type="white">
        <span
          class="tender-steps_item-number">
          {{ $t('Catalog.Step') }} {{ `${stepIndex + 1}${!loading && stepIndex + 1 === +value ? '. '+$t(stepItem.label) : ''}` }}
        </span>
      </sTooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TenderSteps',
  methods: {
    changeStep(step) {
      if (this.disabled || this.loading) {
        return
      }
      if (step !== +this.value) {
        this.$emit('update:value', step)
      }
    }
  },
  props: {
    value: {
      type: [String, Number]
    },
    steps: {
      type: Array
    },
    loading: Boolean,
    disabled: Boolean,
  },
}
</script>
<style scoped lang="scss">
.tender-steps {
  display: flex;
  grid-gap: 24px;
  margin: auto auto;
  &_item {
    $item: &;
    opacity: 0.5;
    transition: 0.25s all;
    &-number {
      cursor: pointer;
    }
    &:hover,
    &:focus,
    &.is-active {
      font-weight: 500;
      opacity: 1;
    }
    &.is-active {
      #{$item}-number {
        cursor: auto;
      }
    }
    &.is-disabled {
      cursor: not-allowed;
      #{$item}-number {
        cursor: not-allowed;
      }
    }
  }
}
</style>
